import {
    GET_RESETPASSWORD_USERINFO,
    GET_RESETPASSWORD_USERINFO_SUCCESSED,
    GET_RESETPASSWORD_USERINFO_FAILED,
    UPDATE_RESETPASSWORD_USERINFO,
    UPDATE_RESETPASSWORD_USERINFO_SUCCESSED,
    SAVE_RESETPASSWORD,
    SAVE_RESETPASSWORD_FAILED,
    SAVE_RESETPASSWORD_SUCCESSED
  } from '../actions/actionTypes'
  
  const initialState = {
    data: {question: null, answer: null, password:null, confirmpassword:null,refnum:null},
    requesting_get: false,
    requesting_get_successful: false,
    requesting_update:false,
    requesting_update_successful:false,
    requesting_save: false,
    requesting_save_successful: false,
    message: null,
    infoError: null,
    loading_message: "Loading resetpassword userinfo..."
  }
  
  function resetPasswordUserInfoReducers(state = initialState, action) {
    switch (action.type) {
      case GET_RESETPASSWORD_USERINFO:
        return Object.assign({}, {
          requesting_get: true,
          requesting_get_successful: false,
          data: Object.assign({}, state.data),
          message: null,
          infoError: null,
          loading_message: "Loading resetpassword userinfo..."
        })
      case GET_RESETPASSWORD_USERINFO_SUCCESSED:
        return Object.assign({}, {
          requesting_get: false,
          requesting_get_successful: true,
          data: Object.assign({}, action.data),
          message: null,
          infoError: null,
          loading_message: state.loading_message
        })
      case GET_RESETPASSWORD_USERINFO_FAILED:
        return Object.assign({}, {
          requesting_get: false,
          requesting_get_successful: false,
          data: Object.assign({}, state.data),
          message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
          infoError: action.infoError || null,
          loading_message: state.loading_message
        })
  
        //update reset userinfo
        case UPDATE_RESETPASSWORD_USERINFO:
          return Object.assign({}, {
            requesting_update: true,
            requesting_update_successful: false,
            data: Object.assign({}, state.data),
            message: null,
            infoError: null,
            loading_message: "Updating resetpassword userinfo..."
          })
        case UPDATE_RESETPASSWORD_USERINFO_SUCCESSED:
          return Object.assign({}, {
            requesting_update: false,
            requesting_update_successful: true,
            data: Object.assign({}, action.data),
            message: null,
            infoError: null,
            loading_message: state.loading_message
          })
        //save resetpassword
        case SAVE_RESETPASSWORD:
          return Object.assign({}, {
            requesting_save: true,
            requesting_save_successful: false,
            data: Object.assign({}, state.data),
            message: null,
            infoError: null,
            loading_message: "Saving resetpassword..."
          })
        case SAVE_RESETPASSWORD_SUCCESSED:
          return Object.assign({}, {
            requesting_save: false,
            requesting_save_successful: true,
            data: Object.assign({}, action.data),
            message: null,
            infoError: null,
            loading_message: state.loading_message
          })
        case SAVE_RESETPASSWORD_FAILED:
          return Object.assign({}, {
            requesting_save: false,
            requesting_save_successful: false,
            data: Object.assign({},state.data),
            message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
            infoError: action.infoError || null,
            loading_message: state.loading_message
          })
      default:
        return state
    }
  }
  
  export default resetPasswordUserInfoReducers;
  